import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { ICONS } from './icons';

// <app-icon name="calendar"></app-icon> — renders one of the shell's inline SVG icons.
// The SVG is written straight into the host element: Angular's [innerHTML] sanitizer strips
// <path>, and the markup comes only from the static ICONS table.
@Component({
    selector: 'app-icon',
    template: '',
    styles: [':host { display: inline-block; flex: 0 0 auto; line-height: 0; } :host ::ng-deep svg { width: 100%; height: 100%; display: block; }']
})
export class IconComponent implements OnChanges {
    @Input() name: string;
    @Input() strokeWidth = 1.9;

    constructor(private el: ElementRef) { }

    ngOnChanges() {
        const body = ICONS[this.name] || '';
        this.el.nativeElement.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + this.strokeWidth + '"' +
            ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>';
    }
}
